/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DThemeDarkMenuItemExpandableItemSpace } from "./d-theme-dark-menu-item-expandable-item-space";

export class DThemeDarkMenuSidedItemExpandableItemSpace extends DThemeDarkMenuItemExpandableItemSpace {}
